import React, { useEffect, useState, useContext } from "react";

import {
  Grid,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  FormControlLabel,
  Switch,
} from "@material-ui/core";

import Chip from "../../../../components/basics/Chip";
import Btn from "../../../../components/buttons/Btn";
import Select from "../../../../components/basics/SelectErp";

import TextField from "../../../../components/basics/TextFieldErp";
import { HeaderModal } from "../../../financeiro/nfe/styles/Emissao";
import { TipoServicoContext } from "../contexts/TipoServicoContext";
import useTipoServicoController from "../controllers/TipoServicoController";

const ModalTipoEditRetencao = ({ open, setOpen, index }) => {
  const {
    listCities,
    listUf,
    tableWithholdings,
    editwithholdingsErrors,
    taxationList,
  } = useContext(TipoServicoContext);

  const { editMunicipalWithholding } = useTipoServicoController();

  const [uf, setUf] = useState(null);
  const [city, setCity] = useState(null);
  const [aliqRet, setAliqRet] = useState("0,00");
  const [reduction, setReduction] = useState("0,00");
  const [listCitiesByUf, setListCitiesByUf] = useState([]);
  const [withheldSn, setWithheldSn] = useState(false);
  const [taxation, setTaxation] = useState({
    value: "None",
    description: "Nenhuma",
  });

  useEffect(() => {
    const copyTableWithholdings = [...tableWithholdings];
    const item = copyTableWithholdings[index];

    setUf(listUf.find((uf) => uf.id.toString() === item.tEstadoId.toString()));

    setCity(
      listCities.find(
        (city) => city.codigo.toString() === item.tMunicipioCodigo.toString()
      )
    );

    setTaxation(
      taxationList.find(
        (taxation) => taxation.value.toString() === item.tTaxacao.toString()
      )
    );

    setAliqRet(item.tAliquotaRetencao);
    setReduction(item.tReducao);
    setWithheldSn(item.tRetemSn);
  }, [index, tableWithholdings, listUf, listCities, taxationList]);

  useEffect(() => {
    if (!uf) return;

    const newList = listCities.filter(
      (city) => city.estado_codigo.toString() === uf.codibge.toString()
    );

    setListCitiesByUf(newList);
  }, [listCities, uf, setListCitiesByUf]);

  useEffect(() => {
    if (!city || !listCitiesByUf.length) return;

    if (
      !listCitiesByUf.find(
        (item) =>
          city.estado_codigo.toString() === item.estado_codigo.toString()
      )
    )
      setCity(null);
  }, [listCitiesByUf, city, setCity]);

  const handleClose = () => {
    setOpen(false);
  };

  const save = () => {
    if (
      editMunicipalWithholding({
        index: index,
        uf: uf,
        city: city,
        aliqRet: aliqRet,
        reduction: reduction,
        listCitiesByUf: listCitiesByUf,
        withheldSn: withheldSn,
        taxation: taxation,
      })
    )
      setOpen(false);
  };

  return (
    <Dialog
      fullWidth={true}
      maxWidth="md"
      open={open}
      onClose={handleClose}
      aria-labelledby="dialog-forma-pagto"
    >
      <HeaderModal>
        <DialogTitle id="dialog-forma-pagto">
          <Chip label="RETENÇÃO" bgcolor="primary" textcolor="white" />
        </DialogTitle>
      </HeaderModal>
      <DialogContent>
        <Grid container>
          <Grid container spacing={2}>
            <Grid item xs={3}>
              <Select
                value={uf}
                setValue={setUf}
                optionsList={listUf}
                descriptionField="estado"
                label="UF"
                error={editwithholdingsErrors.uf}
                helperText={editwithholdingsErrors.uf || ""}
              />
            </Grid>
            <Grid item xs={4}>
              <Select
                value={city}
                setValue={setCity}
                optionsList={listCitiesByUf}
                descriptionField="municipio"
                label="Município"
                error={editwithholdingsErrors.city}
                helperText={editwithholdingsErrors.city || ""}
              />
            </Grid>
            <Grid item xs={4}>
              <Select
                value={taxation}
                setValue={setTaxation}
                optionsList={taxationList}
                descriptionField="description"
                label="Taxação"
                error={editwithholdingsErrors.taxation}
                helperText={editwithholdingsErrors.taxation || ""}
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                label="Alíquota de Retenção (%)"
                value={aliqRet}
                setValue={setAliqRet}
                error={editwithholdingsErrors.aliqRet}
                helperText={editwithholdingsErrors.aliqRet || ""}
                mask="decimal"
                decimals={5}
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                label="Redução (%)"
                value={reduction}
                setValue={setReduction}
                error={editwithholdingsErrors.reduction}
                helperText={editwithholdingsErrors.reduction || ""}
                mask="decimal"
              />
            </Grid>
            <Grid item xs={2}>
              <FormControlLabel
                label="Retém p/ SN"
                labelPlacement="top"
                control={
                  <Switch
                    checked={withheldSn}
                    onChange={() => {
                      setWithheldSn((current) => !current);
                    }}
                    color="primary"
                  />
                }
              />
            </Grid>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Btn onClick={save} label="Salvar" />
        <Btn
          bgcolor="tertiary"
          hovercolor="blue"
          onClick={handleClose}
          label="cancelar"
        />
      </DialogActions>
    </Dialog>
  );
};

export default ModalTipoEditRetencao;
